import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import getLocalData from "../../../shared/localStorage/getData";
import getRemoveData from "../../../shared/localStorage/removeData";
import combinedServices from "../../../shared/services/user-service";
import {
  clubUserDetailsAtom,
  userRaceClubOfficerClubAtom,
  userDistrictsAtom,
} from "../../../recoil/atoms/userAtoms";
import { useRecoilValue, useRecoilState } from "recoil";

const Header = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [isEventManagement, setIsManagement] = useState(false);
  const [isEventManage, setIsEventManage] = useState(true);
    const [userID, setUserID] = useState(0);
    const [hasPOSAccess, setHasPOSAccess] = useState();
    const [isstoreadmin, setIsstoreadmin] = useState(false);
  // const clubUserDetails = useRecoilValue(clubUserDetailsAtom);
  // const userRaceClubOfficerClub = useRecoilValue(userRaceClubOfficerClubAtom);
  // const userDistricts = useRecoilValue(userDistrictsAtom);

  const [clubUserDetails, setClubUserDetails] = useRecoilState(clubUserDetailsAtom);
  const [userRaceClubOfficerClub, setUserRaceClubOfficerClub] = useRecoilState(userRaceClubOfficerClubAtom);
  const [userDistricts, setUserDistricts] = useRecoilState(userDistrictsAtom);



  const db_logo =
    "https://nambaweb.s3.ap-south-1.amazonaws.com/frontend-static-image/db_logo.png";
  const user_img =
    "https://nambaweb.s3.ap-south-1.amazonaws.com/frontend-static-image/user_img.jpg";

  const [userProfile,setUserProfile] = useState(user_img)  

  // useEffect(() => {
  //   if (getLocalData("user_info", "isLogin")) {
  //     setIsLogin(getLocalData("user_info", "isLogin"));
  //     var loginUserData = getLocalData("user_info", "all").userData
  //       .login_user_detail.data.user;
  //           setUserID(loginUserData.id)
  //     var data = {
  //       user_id: loginUserData.id,
  //       clubs: true,
  //       events: true,
  //       district: true,
  //     };

  //     combinedServices.getProfileDetails(data).then((profileResponse) => {
  //       if(profileResponse.data.user_avatar){
  //         setUserProfile(profileResponse.data.user_avatar)
  //       }
  //       if (profileResponse?.data?.resban === "yes") {
  //         setIsEventManage(false);
  //       }
  //       if (
  //         clubUserDetails.length > 0 ||
  //         userRaceClubOfficerClub.length > 0 ||
  //         userDistricts.length > 0
  //       ) {
  //         setIsManagement(true);
  //       }
  //     });
  //   }
  // }, [clubUserDetails,userRaceClubOfficerClub,userDistricts]);

  useEffect(() => {
    if (!getLocalData("user_info", "isLogin")) return;

    setIsLogin(true);
    const loginUserData = getLocalData("user_info", "all").userData.login_user_detail.data.user;
    setUserID(loginUserData.id);

    const data = { user_id: loginUserData.id, clubs: true, events: true, district: true };

    combinedServices.getProfileDetails(data).then(async (profileResponse) => {
      if (profileResponse.data.user_avatar) setUserProfile(profileResponse.data.user_avatar);

      const isBanned = profileResponse?.data?.resban === "yes";
      const clubs = profileResponse.data.club_members || [];
      const officers = profileResponse.data.userRaceClubOfficerClub || [];

      setClubUserDetails(clubs);
      setUserRaceClubOfficerClub(officers);

      const districtsRes = await combinedServices.getUserDistricts(loginUserData.id);
      const districts = districtsRes.status === 200 ? districtsRes.data : [];
      setUserDistricts(districts);

      const hasManagement = clubs.length > 0 || officers.length > 0 || districts.length > 0;

      if (isBanned) {
        setIsEventManage(false);
      } else if (hasManagement) {
        setIsManagement(true);
      }
    });
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const pos = await combinedServices.userPOSstatus({ userID: userID });
        setHasPOSAccess(pos.data.data.StorePOS);
        console.log("POS Status:", pos.data.data.StorePOS);
      } catch (error) {
        console.error("Error fetching POS status:", error);
        setHasPOSAccess(0);
      }
    };
    const fetchstoreData = async () => {
      try {
        const storedata = await combinedServices.getstorebyuserId({
          userId: userID
        });
        if(storedata.data.data.length !== 0) {
          setIsstoreadmin(true);
        } else {
          setIsstoreadmin(false);
        }
      } catch (error) {
        console.error("Error fetching store data:", error);
        setIsstoreadmin(false);
      }
    };
    if (userID) {
      fetchData();
      fetchstoreData();
    }
  }, [userID]);


  const handleLogout = () => {
    getRemoveData("user_info");
    localStorage.clear();
    window.location.href = "/";
  };

  const [isActive, setActive] = useState(false);
  const toggleClass = () => {
    setActive(!isActive);
  };

  return (
    <>
      <a
        className={isActive ? "showDBMenu active" : "showDBMenu"}
        onClick={toggleClass}
      >
        <span>
          <i></i>
          <i></i>
          <i></i>
        </span>
      </a>
      <div className={isActive ? "dbLeft active" : "dbLeft"}>
        <div className="dbLogo">
          <NavLink to="/">
            <img src={db_logo} alt="" />
          </NavLink>
        </div>
        <div className="dbMenu">
          <ul>
            {isEventManagement ? (
              <li key="home">
                <NavLink to="/club-dashboard">
                  <span className="icon">
                    <span className="material-icons" translate="no">
                      home
                    </span>
                  </span>
                  Dashboard Home
                </NavLink>
              </li>
            ) : (
              <li key="user-dashboard">
                <NavLink to="/user-dashboard">
                  <span className="icon">
                    <span className="material-icons" translate="no">
                      home
                    </span>
                  </span>
                  Home
                </NavLink>
              </li>
            )}

            <li key="my-race">
              <NavLink to="/my-race">
                <span className="icon">
                  <span className="material-icons" translate="no">
                    directions_boat
                  </span>
                </span>
                My Races
              </NavLink>
            </li>
            <li key="my-result">
              <NavLink to="/my-result">
                <span className="icon">
                  <span className="material-icons" translate="no">
                    leaderboard
                  </span>
                </span>
                My Results
              </NavLink>
            </li>
            {isEventManagement && isEventManage && (
              <>
                <li key="event-management">
                  <NavLink to="/event-management">
                    <span className="icon">
                      <span className="material-icons" translate="no">
                        date_range
                      </span>
                    </span>
                    Event Management
                  </NavLink>
                </li>
                <li key="paypal-credential">
                  <NavLink to="/paypal-credentail">
                    <span className="icon">
                      <span className="material-icons" translate="no">
                        date_range
                      </span>
                    </span>
                    Paypal Credential
                  </NavLink>
                </li>
              </>
            )}
            <li key="payment">
              <NavLink to="/payment">
                <span className="icon">
                  <span className="material-icons" translate="no">
                    directions_boat
                  </span>
                </span>
                Payments
              </NavLink>
            </li>
                         {isstoreadmin && (
                            <li key="stores">
                                <NavLink to="/adminstorelist">
                                    <span className="icon">
                                        <span className="material-icons" translate="no">store</span>
                                    </span>
                                    Stores
                                </NavLink>
                            </li>
                        )}
                        {hasPOSAccess !== '0' && (
                            <li key="POS">
                                <NavLink to="/poslist">
                                    <span className="icon">
                                        <span className="material-icons" translate="no">point_of_sale</span>
                                    </span>
                                    POS
                                </NavLink>
                            </li>
                        )}
            <li key="logout">
              <NavLink to="#" onClick={handleLogout}>
                <span className="icon">
                  <span className="material-icons" translate="no">
                    logout
                  </span>
                </span>
                Logout
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="userImg">
          <NavLink to="/club-profile">
            <img src={userProfile} alt="" />
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default Header;
